import React, {useContext, useEffect, useState} from 'react';
import ComponentTitle from "../Component-title/ComponentTitle";
import HomeTourItem from "../Home-tour-item/HomeTourItem";
import { axios } from "../../axios";
import {slugify} from "../../helpers";
import {LangContext} from "../../App";
import {Link} from "react-router-dom";

const HomeTours = () => {
    const [tours, setTours] = useState([]);
    const lang = useContext(LangContext)

    useEffect(() => {
        axios.get(`${lang}/private-tour?main_page=true`).then(res => {
            if (Array.isArray(res.data.tours)) {
                setTours(res.data.tours);
            } else {
                console.error('API response is not an array:', res.data);
            }
        }).catch(error => {
            console.error('Error fetching tours:', error);
        });
    }, [lang]);

    const content = {
        en:{
            toursTitle:'Tours'
        },
        de:{
            toursTitle:'Touren'
        }
    }

    const {toursTitle} = content[lang] || content.en

    return (
        <div className='home-tours'>
            <ComponentTitle title='' subTitle='' subTitle2={toursTitle}/>
            <div className="center-wrapper mt-5" style={{marginTop:'20px'}}>
                <div className="list-wrapper" style={{marginTop:'50px'}}>
                    {tours?.slice(0,3).map(e =>{
                        if (!e) return null;
                        const slug = slugify(e?.title || '')
                        return (
                            <Link key={e.id} to={`/${lang}/private-tour/${e.id}/${slug}`}>
                                <HomeTourItem tour={e} />
                            </Link>
                        )
                    }

                    )}
                </div>
            </div>
        </div>
    );
};

export default HomeTours;